import ServicePackageDescription from "%/dynamic-component-editor/standard-components/service-package-card/ServicePackageDescription.vue";
import ServicePackageName from "%/dynamic-component-editor/standard-components/service-package-card/ServicePackageName.vue";
import ServicePackagePrice from "%/dynamic-component-editor/standard-components/service-package-card/ServicePackagePrice.vue";
import LegacyEntity from "%/dynamic-component-editor/classes/LegacyEntity";

export default class LegacyServicePackage extends LegacyEntity {
  get elements() {
    return {
      ServicePackageDescription,
      ServicePackageName,
      ServicePackagePrice,
    };
  }
}
